import FlameIcon from './FlameIcon';
import LevelUpDialog from './LevelUpDialog';
import TemperatureDetailsDialog from './TemperatureDetailsDialog';
import { useChatLevelProgress } from './useChatLevelProgress';
import { getLevelColor } from './useLevelLadder';
import { TemperatureFlames, TemperaturePanel } from './chatSelectedProfile.styles';

const LOADING_FLAME_COUNT = 4;

const ChatLevelProgress = ({
	scoreProgress,
	isLoading = false,
	conversationKey = null,
}) => {
	const {
		t,
		isDetailsOpen,
		isLevelUpOpen,
		celebratedLevel,
		flameLevels,
		accentColor,
		litCount,
		flameCount,
		levelName,
		levelDescription,
		progressPercent,
		progressLabel,
		factorRows,
		highestFactorScore,
		celebratedLitCount,
		celebratedColor,
		openDetails,
		closeDetails,
		closeLevelUp,
	} = useChatLevelProgress(scoreProgress, { conversationKey });

	return (
		<>
			<TemperaturePanel
				type="button"
				onClick={isLoading ? undefined : openDetails}
				disabled={isLoading}
				aria-busy={isLoading}
				aria-label={
					isLoading
						? t.conversationTemperature
						: t.viewConversationTemperature ||
							`${t.conversationTemperature}: ${levelName}`
				}
				$color={accentColor}
			>
				<TemperatureFlames>
					{isLoading
						? Array.from({ length: LOADING_FLAME_COUNT }).map((_, index) => (
								<FlameIcon
									key={`loading-${index}`}
									isLoading
									color={accentColor}
								/>
							))
						: flameLevels.map((level, index) => (
								<FlameIcon
									key={`panel-${level.id}`}
									lit={index < litCount}
									color={getLevelColor(level, accentColor)}
								/>
							))}
				</TemperatureFlames>
			</TemperaturePanel>
			{isDetailsOpen && (
				<TemperatureDetailsDialog
					t={t}
					accentColor={accentColor}
					flameLevels={flameLevels}
					litCount={litCount}
					levelName={levelName}
					progressPercent={progressPercent}
					progressLabel={progressLabel}
					factorRows={factorRows}
					highestFactorScore={highestFactorScore}
					onClose={closeDetails}
				/>
			)}
			{isLevelUpOpen && celebratedLevel && (
				<LevelUpDialog
					t={t}
					celebratedLevel={celebratedLevel}
					celebratedColor={celebratedColor}
					celebratedLitCount={celebratedLitCount}
					flameLevels={flameLevels}
					flameCount={flameCount}
					levelDescription={levelDescription}
					onClose={closeLevelUp}
				/>
			)}
		</>
	);
};

export default ChatLevelProgress;
